'use strict';

var util = angular.module('gymsystem.util');

util.directive('liquidity', ['echartslib', 'util', 'formatter', function(echartslib, util, formatter) {
    return {
        restrict: 'E',
        scope: {
            settings: '='
        },
        link: function($scope, ele) {
            $scope.$watch('settings', function() {
                echartslib.load().then(function() {
                    var width = ele.parent().parent().width();
                    var height = ele.parent().parent().height() || $('.page').height();
                    ele.css('width', width + 'px');
                    ele.css('height', height + 'px');
                    var chart = echarts.init(ele[0]);

                    var from = Date.newFull($scope.settings.fromDate);
                    var to = Date.newFull($scope.settings.toDate);
                    var d = from.clone();
                    var xAxis = [];
                    while (d <= to) {
                        xAxis.push(d.yyyymmdd());
                        d = d.addDays(1);
                    }

                    var serie1 = xAxis.map(function() {
                        return 10000 + Math.floor((Math.random() - 0.5) * 1000);
                    });

                    var option = {
                        xAxis: {
                            type: 'category',
                            data: xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        tooltip: {
                            formatter: function(params) {
                                return formatter.format('price', params.value);
                            }
                        },
                        series: [{
                            data: serie1,
                            type: 'line',
                            itemStyle: {
                                color: '#349df1'
                            },
                            areaStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: '#349df1' // color at 0% position
                                    }, {
                                        offset: 1, color: 'white' // color at 100% position
                                    }],
                                    global: false // false by default
                                }
                            },
                            smooth: true
                        }]
                    };

                    if ($scope.settings.zoom) {
                        option.dataZoom = [{
                            startValue: xAxis[0]
                            }, {
                                type: 'inside'
                            }
                        ];
                    }

                    chart.setOption(option);
                });
            });
        }
    };
}]);
